import React, { useContext } from 'react'
import Input from 'src/components/forms/input'
import Button from 'src/components/button'
import * as S from './styles'
import { isEmailValid } from 'utils'
import { RootContext } from 'context/rootContext'
import useForm from './hooks/useForm'

const ForgotPasswordForm = ({ successCallback, confirmLabel }) => {
  const context = useContext(RootContext)
  const { errors, clearErrors, watch, register, setError, submitForm } = useForm()

  const handleValidateEmail = ({ callback }) => {
    const email = watch.email
    if (isEmailValid(email)) {
      clearErrors('email')
      callback()
    } else {
      setError('email', {
        type: 'manual',
        message: 'Email inválido'
      })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    handleValidateEmail({ callback: () => submitForm({ successCallback, context, setError }) })
  }

  return (
    <>
      <S.Form onSubmit={(e) => handleSubmit(e)}>
        <Input
          name='email'
          type='email'
          label='Email'
          value={watch.email}
          placeholder='Digite seu e-mail'
          margin='8px auto 0 auto'
          hookForm={register('email', { required: true })}
          errorMessage={errors.email?.message}
        />

        <S.Footer>
          {confirmLabel && <Button margin='0' theme='primary' type='submit'>{confirmLabel}</Button>}
        </S.Footer>
      </S.Form>
    </>
  )
}

export default ForgotPasswordForm
